var currentIndex = 0;

function getCSSVariablesMedia() {
  var bodyStyles = window.getComputedStyle(document.body);
  var mediaCarouselCSSVariables = {
    itemWidth: parseInt(bodyStyles.getPropertyValue('--mediaCarousel_item_width')),
    itemLargeWidth: parseInt(bodyStyles.getPropertyValue('--mediaCarousel_large_item_width')),
    itemGap: parseInt(bodyStyles.getPropertyValue('--mediaCarousel_item_gap')),
    itemsToShow: parseInt(bodyStyles.getPropertyValue('--mediaCarousel_items_to_show')),
    itemsToSlide: parseInt(bodyStyles.getPropertyValue('--mediaCarousel_items_to_show')),
    itemsToShowBP2: parseInt(bodyStyles.getPropertyValue('--mediaCarousel_items_to_show_bp2'))
  };
  return mediaCarouselCSSVariables;
}

function getMaxIndexMedia(element) {
  var childCount = element.attr('data-child-count');
}

function addNavigationMedia() {
  var $chevronLeft = $('<i/>')
    .addClass("fa-solid fa-chevron-left disabled")
    .attr("data-parent", "media-carousel")
    .prependTo('.mediaCarouselContainer');
  
  var $rightButton = $("<i/>")
    .addClass("fa-solid fa-chevron-right")
    .attr("data-parent", "media-carousel")
    .appendTo('.mediaCarouselContainer');

  getCSSVariablesMedia().itemsToShow >= parseInt($rightButton.siblings('.mediaCarousel').find('.mediaCarouselItems').attr('data-child-count')) ? $rightButton.addClass('disabled') : $rightButton.removeClass('disabled');
  showItemsMedia();
}

function showItemsMedia() {
  $('.mediaCarouselItems').each(function() {
    $(this).addClass('visible');
    var childCount = $(this).attr('data-child-count');
    var $associatedRightButton = $(this).parent('.mediaCarousel').siblings('.fa-chevron-right');
    var $loadingText = $(this).parents(".wrapper").find(".loadingText");
    $loadingText.remove();
    $(".mediaPreview").css("display", "flex");
    getCSSVariablesMedia().itemsToShow >= childCount ? $associatedRightButton.addClass('disabled') : $associatedRightButton.removeClass('disabled');
  })
}

function getFullResImages() {
  $('.mediaCarousel .mediaCarouselItems img:not(:first-child)').css("display", "block");
  $('.mediaCarouselItems img.preload').each(function() {
    $(this).attr("src", $(this).data("fullres"));
    $(this).removeClass("preload");
  })
}

function wrapCarouselMedia() {
  var $mediaCarousel = $('<div/>')
    .addClass('mediaCarousel');
  $('.mediaCarouselItems').wrap($mediaCarousel);
  $('.mediaCarouselItems').attr('data-offset', 0);

  var $mediaCarouselContainer = $('<div/>')
    .addClass('mediaCarouselContainer');
  $('.mediaCarousel').wrap($mediaCarouselContainer);

  if ($(".mediaCarouselItems").find("model-viewer").length != 0) {
    var $arMessage = $('<p/>')
      .attr("id", "arMessage")
      .text("Open this website on your phone to view this product in your room")
      .appendTo(".mediaCarouselContainer");

    var $360message = $('<i/>')
      .addClass("fa-solid fa-360-degrees")
      .appendTo(".mediaCarouselContainer");
  }
  
  var $zoomButton = $('<i/>')
    .addClass('fa-solid fa-magnifying-glass-plus')
    .off('click').on('click', function() {
      $("body").addClass("scrollingDisabled");
      $(`.modalContainer[data-content='media-carousel']`).addClass("visible");
    })
    .appendTo(".mediaCarouselContainer");
  
  addNavigationMedia();
}

$('.mediaCarouselItems img').off('click').on('click', function() {
  if ($(window).width() > 1024) {
    $("body").addClass("scrollingDisabled");
    $(`.modalContainer[data-content='media-carousel']`).addClass("visible");
  }
});
$('.mediaCarouselItems.large img').off('click').on('click', function() {
  if ($(window).width() > 1024) {
    $("body").removeClass("scrollingDisabled");
    $(this).parents(".modalContainer").removeClass("visible");
  }
});

wrapCarouselMedia();
$(window).resize(function() {
  getCSSVariablesMedia();
});

$(".mediaItem").off('click').on('click', function() {
  getFullResImages();
  currentIndex = parseInt($(this).find("img").attr('data-index'));
  var childCount = parseInt($(this).parent().attr('data-child-count'));
  var thisCarousel = $(this).parent().siblings(".mediaCarouselContainer").find(".mediaCarouselItems");
  var otherCarousel = $(".mediaCarouselItems").not(thisCarousel);
  var leftChevron = $(this).parent().siblings(".mediaCarouselContainer").find(".fa-solid.fa-chevron-left");
  var rightChevron = $(this).parent().siblings(".mediaCarouselContainer").find(".fa-solid.fa-chevron-right");
  var otherCarouselLeftChevron = otherCarousel.parent().siblings(".fa-solid.fa-chevron-left");
  var otherCarouselRightChevron = otherCarousel.parent().siblings(".fa-solid.fa-chevron-right");
  
  currentIndex > 0 ? leftChevron.removeClass('disabled') : leftChevron.addClass('disabled');
  //currentIndex < childCount - 1 ? rightChevron.removeClass('disabled') : rightChevron.addClass('disabled');
  currentIndex > 0 ? otherCarouselLeftChevron.removeClass('disabled') : otherCarouselLeftChevron.addClass('disabled');
  //currentIndex < childCount - 1 ? otherCarouselRightChevron.removeClass('disabled') : otherCarouselRightChevron.addClass('disabled');
  if (currentIndex == childCount) {
    currentIndex = 0;
  }

  thisCarousel.css({"transform": `translateX(${(100*currentIndex)*-1}%)`});
  otherCarousel.not(thisCarousel).css({"transform": `translateX(${(100*currentIndex)*-1}%)`});
  thisCarousel.attr('data-offset', currentIndex);
  otherCarousel.attr('data-offset', currentIndex);
  thisCarousel.children().eq(currentIndex).addClass("current");
  thisCarousel.children().not(`:eq(${currentIndex})`).removeClass("current");
  otherCarousel.children().eq(currentIndex).addClass("current");
  otherCarousel.children().not(`:eq(${currentIndex})`).removeClass("current");
});

$(document).ready(function() {
  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  
  function loadFullResImages() {
    $(".mediaCarousel img").each(function() {
      var $currentImage = $(this);
      if ($currentImage.isInViewport() && $currentImage.hasClass("preload")) {
        $currentImage.attr('srcset', $(this).attr("data-srcset-temp")).load(function() {
        if ($currentImage.hasClass("preload")) {
          $currentImage.attr('srcset', $(this).attr("data-srcset-temp"));
          $currentImage.attr("src", "");
        }
        $currentImage.removeClass("preload");
        });
      }
    });
  };
  
  loadFullResImages();

  $(window).on('scroll', function() {
    loadFullResImages();
  });

  $(document).on('click', 'i[data-parent="media-carousel"]', function() {
    var chevron = $(this);
    var associatedChevron = chevron.siblings("i");
    if (!chevron.hasClass("disabled")) {
      var thisCarousel = chevron.siblings(".mediaCarousel").find('.mediaCarouselItems');
      var otherCarousel = $(".mediaCarouselItems").not(thisCarousel);
      var childCount = parseInt(thisCarousel.attr('data-child-count'));
      var otherCarouselLeftButton = otherCarousel.parent().siblings(".fa-chevron-left");
      var otherCarouselRightButton = otherCarousel.parent().siblings(".fa-chevron-right");
      currentIndex = parseInt(thisCarousel.attr('data-offset'));
      
      var itemsToShow = getCSSVariablesMedia().itemsToShow;
      
      if (chevron.hasClass("fa-chevron-right")) {
        var remainingItems = childCount - (itemsToShow + currentIndex);
        itemsToShow > remainingItems ? currentIndex += remainingItems : currentIndex += itemsToShow;
        if (currentIndex < childCount - itemsToShow) {
          chevron.removeClass('disabled')
        }
        if (remainingItems == 0) {
          currentIndex = 0;
        }
        currentIndex > 0 ? associatedChevron.removeClass('disabled') : associatedChevron.addClass('disabled');
      }
      else {
        itemsToShow > currentIndex ? currentIndex = 0 : currentIndex -= itemsToShow;
        currentIndex > 0 ? chevron.removeClass('disabled') : chevron.addClass('disabled');
        currentIndex < childCount - itemsToShow ? associatedChevron.removeClass('disabled') : associatedChevron.addClass('disabled');
      }
      thisCarousel.attr('data-offset', currentIndex);
      thisCarousel.css({"transform": `translateX(${(100*currentIndex)*-1}%)`});
      otherCarousel.attr('data-offset', currentIndex);
      otherCarousel.css({"transform": `translateX(${(100*currentIndex)*-1}%)`});
      currentIndex > 0 ? otherCarouselLeftButton.removeClass('disabled') : otherCarouselLeftButton.addClass('disabled');
      currentIndex < childCount - itemsToShow ? otherCarouselRightButton.removeClass('disabled') : otherCarouselRightButton.addClass('disabled');
      thisCarousel.children().eq(currentIndex).addClass("current");
      thisCarousel.children().not(`:eq(${currentIndex})`).removeClass("current");
      otherCarousel.children().eq(currentIndex).addClass("current");
      otherCarousel.children().not(`:eq(${currentIndex})`).removeClass("current");
    }
  });
});